import React from "react";
import { useHistory } from "react-router-dom";
import { getSingleRoute } from "../../../common/utils";
import { getQueryString } from "../../common/getQueryString";

function CountryDisciplines(props) {
    const { countryDetail, disciplines } = props;
    const history = useHistory();
    const checkResults = (degree_Level, discipline) => {
        let obj = {
            // page: "country",
            discipline: [discipline.slug],
            country: [countryDetail.slug],
            levels: [degree_Level.slug],
        }
        history.push({
            pathname: "/search",
            search: getQueryString(obj),
        });
        getRoute('search', { search: getQueryString(obj) })
    };
    const getRoute = (page, id) => {
        getSingleRoute(page).then(d => {
            history.push({
                pathname: d,
                search: id?.search ? id?.search : '',
            });
        })
    }
    return (
        <div>
            <section className="twelveFlex">
                {disciplines
                    ? disciplines?.map((item) => (
                        <div className="twelveBox">
                            <div className="imgWrap">
                                <button
                                    onClick={() => getRoute('discipline_detail', {
                                        search: `?discipline=${item.slug}&country=${countryDetail.slug}`,
                                        // search: $.param({
                                        //     cnt: [{id:countryDetail.id}],
                                        //     dcp: [{id:item.id}],
                                        // })
                                    })}
                                // to={{
                                //     pathname: "/discipline-detail",
                                //     search: $.param({
                                //         cnt: [{id:countryDetail.id}],
                                //         dcp: [{id:item.id}],
                                //     }),
                                // }}
                                >
                                    <img src={item.logo} alt={item.name} />
                                    <div className="titleBox">
                                        <img src={item.icon} alt={item.name + '_ico'} />
                                        <h6 key={item.id}>{item.name}</h6>
                                    </div>
                                </button>
                            </div>
                            <div className="dropdown">
                                <button
                                    className="btn"
                                    type="button"
                                    id="dropdownMenuButton"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                >
                                    <span>Undergraduate</span>
                                    <i className="fa fa-angle-right" />
                                </button>

                                <div
                                    className="dropdown-menu"
                                    aria-labelledby="dropdownMenuButton"
                                >
                                    {item.undergraduate?.length > 0 ? (
                                        item.undergraduate.map((newitem) => (
                                            <button
                                                key={newitem.id}
                                                className="dropdown-item"
                                                onClick={() => checkResults(newitem, item)}
                                            >
                                                {newitem.name ? newitem.name : "Degree not available"}
                                            </button>
                                        ))
                                    ) : (
                                        <button className="dropdown-item" disabled={true}>
                                            Degree not available
                                        </button>
                                    )}
                                </div>
                            </div>

                            <div className="dropdown">
                                <button
                                    className="btn"
                                    type="button"
                                    id="dropdownMenuButton"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                >
                                    <span>Postgraduate</span>
                                    <i className="fa fa-angle-right" />
                                </button>
                                <div
                                    className="dropdown-menu"
                                    aria-labelledby="dropdownMenuButton"
                                >
                                    {item.postgraduate?.length > 0 ? (
                                        item.postgraduate.map((newitem) => (
                                            <button
                                                key={newitem.id}
                                                onClick={() => checkResults(newitem, item)}
                                                className="dropdown-item"
                                            >
                                                {newitem.name ? newitem.name : "Degree not available"}
                                            </button>
                                        ))
                                    ) : (
                                        <button className="dropdown-item" disabled={true}>
                                            Degree not available
                                        </button>
                                    )}
                                </div>
                            </div>

                            <div className="dropdown">
                                <button
                                    className="btn"
                                    type="button"
                                    id="dropdownMenuButton"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                >
                                    <span>Postgraduate by Research</span>
                                    <i className="fa fa-angle-right" />
                                </button>
                                <div
                                    className="dropdown-menu"
                                    aria-labelledby="dropdownMenuButton"
                                >
                                    {item?.research?.length > 0 ? (
                                        item.research.map((newitem) => (
                                            <button
                                                key={newitem.id}
                                                onClick={() => checkResults(newitem, item)}
                                                className="dropdown-item"
                                            >
                                                {newitem.name ? newitem.name : "Degree not available"}
                                            </button>
                                        ))
                                    ) : (
                                        <button className="dropdown-item" disabled={true}>
                                            Degree not available
                                        </button>
                                    )}
                                </div>
                            </div>

                        </div>
                    ))
                    : ""}
            </section>
        </div>
    );
}

export default CountryDisciplines;
